<!-- Enhanced Modern Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 shadow-xl border-b-4 border-blue-200 overflow-hidden"
  style="margin-bottom: 12px"
>
  <!-- Decorative Background Pattern -->
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0"
      style="
        width: 384px;
        height: 384px;
        background: #3b82f6;
        border-radius: 9999px;
        filter: blur(96px);
      "
    ></div>
    <div
      class="absolute bottom-0 right-0"
      style="
        width: 384px;
        height: 384px;
        background: #6366f1;
        border-radius: 9999px;
        filter: blur(96px);
      "
    ></div>
  </div>

  <div
    class="relative flex items-center justify-between"
    style="padding: 12px 32px"
  >
    <div class="flex-1">
      <div class="flex items-center" style="gap: 12px">
        <!-- Icon Badge -->
        <div
          class="flex-shrink-0 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
          style="width: 48px; height: 48px"
        >
          <svg
            class="text-white"
            style="width: 24px; height: 24px"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
        </div>

        <!-- Title Section -->
        <div>
          <h1
            class="text-xl font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent"
            style="margin: 0"
          >
            Add Vehicle
          </h1>
          <p class="text-sm text-gray-600 font-medium" style="margin: 0">
            Vehicle Management System
          </p>
        </div>
      </div>
    </div>

    <div class="flex items-center" style="gap: 12px">
      @if (filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="group flex items-center text-white rounded-xl transition-all duration-300 shadow-lg hover:shadow-2xl font-semibold text-sm border-2 border-blue-400/50 hover:border-blue-300 transform hover:-translate-y-0.5 cursor-pointer bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
        style="padding: 8px 24px; gap: 8px"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          class="text-base group-hover:rotate-90 transition-transform duration-300"
        ></span>
        <span>Hide Filters</span>
      </button>
      } @if (!filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="group flex items-center text-white rounded-xl transition-all duration-300 shadow-lg hover:shadow-2xl font-semibold text-sm border-2 border-slate-400/50 hover:border-slate-300 transform hover:-translate-y-0.5 cursor-pointer bg-gradient-to-r from-slate-500 to-slate-600 hover:from-slate-600 hover:to-slate-700"
        style="padding: 8px 24px; gap: 8px"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          class="text-base group-hover:rotate-90 transition-transform duration-300"
        ></span>
        <span>Show Filters</span>
      </button>
      }
    </div>
  </div>

  <!-- Bottom Accent Line -->
  <div
    class="absolute bottom-0 left-0 right-0 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500"
    style="height: 4px"
  ></div>
</div>

<!-- Statistics Cards Section -->
<div
  class="grid grid-cols-1 md:grid-cols-3"
  style="gap: 16px; margin-bottom: 12px; padding: 0 16px"
>
  <!-- Total Vehicles Card -->
  <div
    class="bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    style="padding: 20px"
  >
    <div class="flex items-center justify-between">
      <div>
        <p
          class="text-sm font-semibold text-gray-600 uppercase tracking-wide"
          style="margin-bottom: 4px"
        >
          Total Vehicles
        </p>
        <p class="text-3xl font-bold text-gray-900" style="margin: 0">
          {{ totalVehicles }}
        </p>
      </div>
      <div
        class="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg"
        style="width: 64px; height: 64px"
      >
        <svg
          class="text-white"
          style="width: 32px; height: 32px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
    </div>
  </div>

  <!-- Total Devices Card -->
  <div
    class="bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    style="padding: 20px"
  >
    <div class="flex items-center justify-between">
      <div>
        <p
          class="text-sm font-semibold text-gray-600 uppercase tracking-wide"
          style="margin-bottom: 4px"
        >
          Total Devices
        </p>
        <p class="text-3xl font-bold text-gray-900" style="margin: 0">
          {{ totalDevices }}
        </p>
      </div>
      <div
        class="bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center shadow-lg"
        style="width: 64px; height: 64px"
      >
        <svg
          class="text-white"
          style="width: 32px; height: 32px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          ></path>
        </svg>
      </div>
    </div>
  </div>

  <!-- Installed Devices Card -->
  <div
    class="bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    style="padding: 20px"
  >
    <div class="flex items-center justify-between">
      <div>
        <p
          class="text-sm font-semibold text-gray-600 uppercase tracking-wide"
          style="margin-bottom: 4px"
        >
          Installed Devices
        </p>
        <p class="text-3xl font-bold text-gray-900" style="margin: 0">
          {{ installedDevices }}
        </p>
        @if (totalVehicles > 0) {
        <p class="text-xs text-gray-500" style="margin-top: 4px">
          {{ ((installedDevices / totalVehicles) * 100).toFixed(1) }}% of
          vehicles
        </p>
        }
      </div>
      <div
        class="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg"
        style="width: 64px; height: 64px"
      >
        <svg
          class="text-white"
          style="width: 32px; height: 32px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</div>

<!-- Filter Panel -->
<div
  [class.hidden]="!filterPanelOpen"
  style="margin-bottom: 12px; padding: 0 16px"
>
  <div
    class="bg-white rounded-xl shadow-md border border-gray-200"
    style="padding: 16px"
  >
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      style="gap: 16px"
    >
      <!-- Client Select -->
      <div style="display: flex; flex-direction: column; gap: 8px">
        <label class="block text-sm font-semibold text-gray-700"
          >Select Client</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Client"
          [(ngModel)]="selectedclnt"
          (ngModelChange)="slct_clnt($event)"
          style="width: 100%"
        >
          @for (c of clnts; track c) {
          <nz-option [nzLabel]="c.clnt_nm" [nzValue]="c.clnt_id"></nz-option>
          }
        </nz-select>
      </div>

      <!-- Tenant/ULB Select -->
      <div style="display: flex; flex-direction: column; gap: 8px">
        <label class="block text-sm font-semibold text-gray-700"
          >Select ULB</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select ULB"
          [(ngModel)]="selectedTnt"
          (ngModelChange)="slct_tnt($event)"
          style="width: 100%"
        >
          @for (t of tnts; track t) {
          <nz-option [nzLabel]="t.tnt_nm" [nzValue]="t.tnt_id"></nz-option>
          }
        </nz-select>
      </div>

      <!-- Get Details Button -->
      <div class="flex items-end">
        @if (vchlDtaBtn) {
        <button
          nz-button
          nzType="primary"
          (click)="getAsrtDtls()"
          class="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
          style="height: 40px"
        >
          Get Details
        </button>
        }
      </div>
    </div>
  </div>
</div>

<!-- Data Grid Section -->
<div style="padding: 0 16px; margin-bottom: 12px">
  <div
    class="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden"
  >
    <app-data-grid
      id="grid"
      class="gridHeight"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="vechile_lst"
      [legacyColumns]="columnDefs"
      [toolbarItems]="gridToolbar"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="Vechile_lst"
      [pageSize]="30"
      [allowedPageSizes]="[10, 30, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="false"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="openSideBar('Edit', data.data)">
            <span
              class="text-xs font-semibold text-green-600 hover:text-green-700 cursor-pointer"
              >Edit</span
            >
          </div>
        </div></ng-template
      >

      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        [width]="100"
        caption="Delete"
        cellTemplate="delTemplate"
      ></app-grid-column>
      <ng-template appGridCell="delTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="showDeleteConfirm(data.data)">
            <span
              class="text-xs font-semibold text-red-600 hover:text-red-700 cursor-pointer"
              >Delete</span
            >
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
</div>

<!-- Add New Vehicle / Add New Device drawers (shared with the vehicle dashboard) -->
<app-add-vehicle-device
  #vhclFrms
  [clntId]="selectedclnt"
  [tntId]="selectedTnt"
  (saved)="onSaved()"
  (masterDataLoaded)="onMstrDta($event)"
  (contextChange)="onCtxChange($event)"
></app-add-vehicle-device>
